import { render, staticRenderFns } from "./ChatBoxQRCode.vue?vue&type=template&id=d51cb38a&scoped=true&"
import script from "./ChatBoxQRCode.vue?vue&type=script&lang=js&"
export * from "./ChatBoxQRCode.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxQRCode.vue?vue&type=style&index=0&id=d51cb38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51cb38a",
  null
  
)

export default component.exports